
import { Component, Vue } from "vue-property-decorator";
import * as Models from "@gigalot/data-models";
import { listTreatment } from "@/helpers/graphql-list-items";
import { getItemFromServer } from "@/helpers/get-item-from-server";

@Component
export default class TreatmentData extends Vue {
  treatments: { guid: string; description?: string; numDoses?: number }[] = [];
  searchTerm = "";
  detailsDialog = false;
  isLoadingDetails = false;
  details: Models.Treatment | null = null;

  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => this.$router.go(-1),
    });
    this.loadTreatments();
  }

  async loadTreatments() {
    this.treatments = await listTreatment(true);
  }

  get filteredTreatments() {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) return this.treatments;
    return this.treatments.filter((treatment) => (treatment.description || "").toLowerCase().includes(term));
  }

  async openTreatmentDetails(treatment: { guid: string }) {
    this.details = null;
    this.detailsDialog = true;
    this.isLoadingDetails = true;
    try {
      this.details = await getItemFromServer("Treatment", treatment.guid);
    } finally {
      this.isLoadingDetails = false;
    }
  }

  closeTreatmentDetails() {
    this.detailsDialog = false;
    this.details = null;
  }

  doseKey(dose: Models.Dose, index: number): string | number {
    return (dose.item && dose.item.description) || index;
  }

  doseDescription(dose: Models.Dose, index: number): string {
    return (dose.item && dose.item.description) || `Dose ${index + 1}`;
  }

  formatDoseLabel(dose: Models.Dose): string {
    const amount = dose.amount !== undefined ? dose.amount : "";
    const unit = dose.unit || "cc";
    if (dose.type === "cc-mass-dependent") {
      const kgPerDose = dose.kgPerDose !== undefined ? dose.kgPerDose : "?";
      return unit === "each" ? `${amount} per ${kgPerDose} kg` : `${amount} ${unit} per ${kgPerDose} kg`;
    }
    return `${amount} ${unit}`;
  }
}
